/*
 * @Description:
 * @Author: WangYuhan
 * @Date: 2022-12-26 16:04:45
 * @LastEditTime: 2024-04-24 13:56:47
 * @LastEditors: lijinpeng
 */
import { get, post, prefix } from './base';

// 获取平安交易明细-筛选条件
export function getAccountCenterQueryCondition(params) {
  return get(`${prefix}openAccountV2/account_center_query_condition`, params);
}

// 获取平安交易明细列表
export function postQueryTradeInfo(data) {
  return post(`${prefix}openAccountV2/account_center_query_tradeInfo`, data);
}

// 平安交易明细导出
export const tradeInfoExportUrl = `${prefix}openAccountV2/account_center_export_tradeInfo`;

// 获取神通物联交易明细-筛选条件
export function getTranFlowSTWCriteria(params) {
  return get(`${prefix}shentong/tran/flow/filter/criteria`, params);
}

// 获取神通物联交易明细列表
export function postTranFlowSTWLList(data) {
  return post(`${prefix}shentong/tran/flow/pageList`, data);
}

// 神通物联交易明细导出
export const tranFlowSTWLExportUrl = `${prefix}shentong/tran/flow/export`;

// 统计月的数据
export function getDataReportInfoMonth(params) {
  return get(`${prefix}etc/etcwx/v3/bill/getDataReportInfoMonth`, params);
}

// 获取交易明细
export function getNybTransDetail(params) {
  return get(`${prefix}etc/etcwx/nyb/transDetail`, params);
}

// 获取交易明细统计
export function getNybTransDetailStatistic(params) {
  return get(`${prefix}etc/etcwx/nyb/transDetailStatistic`, params);
}

// 油气交易明细（PC端）
export function oilConsumeDetail(params) {
  return get(`${prefix}oil/oilConsumeDetail`, params);
}

// 统计数据
export function waybillInvoiceCountData(val) {
  return get(`${prefix}admin/waybillInvoice/countData`, val);
}

// 申请开票
export function applyFromOneStop(val) {
  return post(`${prefix}admin/waybillInvoice/applyFromOneStop`, val);
}

// 申请开票-备注
export function getWaybillRemarkByWaybillNos(val) {
  return post(`${prefix}admin/waybillInvoice/get_waybill_remark`, val);
}

// 申请开票-新20241105
export function applyInvoice(val, config = {}) {
  return post(`${prefix}admin/waybillInvoice/apply_invoice`, val, { customErrorHandler: true });
}
// 网货发票->待开票-已申请
export function waybillInvoiceList(val) {
  return get(`${prefix}admin/v2/waybillInvoice/list`, val);
}

// 网货发票网货发票->开票中-已开票
export function invoiceList(val) {
  return get(`${prefix}admin/v2/invoice/list`, val);
}

// 查询运单ETC费用项列表
export function waybillEtcItemPageList(val) {
  return get(`${prefix}own/waybill/waybillEtcItemPageList`, val);
}

// 查询运单通行交易记录列表
export function listEtcWaybillOrderByWaybillNo(val) {
  return get(`${prefix}waybill/v2/listEtcWaybillOrderByWaybillNo`, val);
}

// 企业油款帐户列表
export function tranPageList(val) {
  return post(`${prefix}oil/account/tran/pageList`, val);
}

// 网货发票->待开票-已申请
export const waybillInvoiceExport = `${prefix}admin/v2/invoice/waybill/export`;

// 导出油气交易明细
export const exportOilConsumeDetail = `${prefix}oil/exportOilConsumeDetail`;

// 交易明细导出
export const nybTransDetailExportUrl = `${prefix}etc/etcwx/nyb/transDetailExport`;

// 月账单导出
export const nybMonthBillExportUrl = `${prefix}etc/etcwx/v3/bill/downloadReportInfoMonth`;

export const tranExport = `${prefix}oil/account/tran/export`;
